'use client'

import ImageWithPlaceholder from './ImageWithPlaceholder'
import Link from 'next/link'

interface ThumbnailProps {
  src: string | null | undefined
  alt: string
  href?: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function Thumbnail({
  src,
  alt,
  href,
  className = '',
  size = 'md',
}: ThumbnailProps) {
  const thumbnailSrc = src?.replace('/uploads/images/', '/uploads/thumbnails/') || src

  const image = (
    <div className={`relative w-full aspect-video overflow-hidden rounded-2xl bg-gray-100 ${className}`}>
      <ImageWithPlaceholder
        src={thumbnailSrc}
        alt={alt}
        fill
        objectFit="cover"
      />
    </div>
  )

  if (href) {
    return <Link href={href}>{image}</Link>
  }

  return image
}

